export const toTestId = (value) => value.replace(/[./]/g, '-');

export default toTestId;
